import { render, staticRenderFns } from "./cRegisterDoc.vue?vue&type=template&id=78abd6ac&scoped=true"
import script from "./cRegisterDoc.vue?vue&type=script&lang=js"
export * from "./cRegisterDoc.vue?vue&type=script&lang=js"
import style0 from "./cRegisterDoc.vue?vue&type=style&index=0&id=78abd6ac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78abd6ac",
  null
  
)

export default component.exports